// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import * as TvIcons from '../../assets/img/channels';
import { getPrivateIconUrl } from '../../config/urls';

type Props = {
  className?: string;
  tvChannel: string;
};

const Icon = styled.div`
  ${({ $src }) => {
    return css`
      width: 3em;
      height: 1.3em;
      background-image: url(${$src});
      background-repeat: no-repeat;
      background-size: contain;
      background-position: right;
    `;
  }};
`;

const TvIcon = ({ className, tvChannel = '' }: Props) => {
  const src = useMemo(() => {
    let result = TvIcons[tvChannel];

    if (!result) {
      result = getPrivateIconUrl(tvChannel);
    }

    return result;
  }, [tvChannel]);

  if (src) {
    return <Icon className={className} $src={src} />;
  }
  return null;
};

export default TvIcon;
